import React from 'react';
import { useDashboardFeatureFlags } from '@components';
import { useOnboardingSummaryQuery } from '@modules/Dashboard/Home/queries/useOnboardingSummaryQuery';
import { HomeProductsSlider } from '../../../../ProductsSlider';
export const useHomeProductsRecommendation = (ignoreOnboardingStatus = false) => {
    const { dashboardFeatureFlags } = useDashboardFeatureFlags();
    const { onboardingSummaryQuery } = useOnboardingSummaryQuery(undefined, {
        enabled: dashboardFeatureFlags.homeProducts.enabled,
    });
    const isFeatureEnabled = dashboardFeatureFlags.homeProducts.enabled;
    const isProductCreated = onboardingSummaryQuery.data?.recommendations.find((item) => item.action.type === 'CreateNewProduct')?.action.status === 'Completed';
    const enabled = isFeatureEnabled && (ignoreOnboardingStatus || isProductCreated);
    return {
        homeProductsRecommendation: {
            id: 'homeProducts',
            enabled,
            isLoading: onboardingSummaryQuery.isInitialLoading,
            suggestion: React.createElement(HomeProductsSlider, null),
        },
    };
};
